module.exports = __webpack_public_path__ + "d6c0505e6757bd0caad2c28916c7e370.woff2";